import { Protocol } from './_types';

export const LIB_PROTOCOL_PEAR_HARVEST_SCREEN_EVAL: Protocol = {
    id: "pear_harvest_screen_eval",
    title: "Advanced Pear Harvest Evaluation",
    description: "Harvest evaluation is performed to characterise new cultivars and selections on the base of their fruit traits. Visual and sensory fruit evaluation are applied to describe fruit quality and keeping ability after storage over a specified storage period. Characteristics such as colour and pattern, shapes and symmetry, defects and disorders and eating quality are evaluated in detail.",
    sampleType: "harvest",

    chars: [
        "frut_ripe_stage",
        "frut_ripe_uniformity",
        "frut_mature_rate",

        "frut_size",
        "frut_over_color",
        "frut_ground_color_stone",
        "frut_over_color_uniform",
        "frut_flesh_color",
        "frut_over_area",
        "frut_over_pattern",
        "frut_skin_bloom",
        "frut_pit_color",

        "frut_shape_type_pear",
        "frut_shape_symmetry",
        "frut_shape_consistent",
        "frut_calyx_depth",
        "frut_calyx_width",
        "frut_stem_length",
        "frut_stem_thick",

        "frut_abrasion",
        "frut_blemish",
        "frut_russet",
        "frut_russet_pos_pear",
        "frut_russet_type",
        "frut_lenticel",

        "frut_taste_sugar",
        "frut_taste_acid",
        "frut_taste_balance",
        "frut_taste_astringe",
        "frut_taste_aroma",
        "frut_taste_juice",
        "frut_skin_thick",
        "frut_text_firm",
        "frut_text_crisp",
        "frut_text_meal",
        "frut_text_butter",
        "frut_text_crunch",
        "frut_text_grain",
        "frut_stonecell",


        "frut_disease_pome",
        "frut_extdisorder_pome",
        "frut_intdisorder_pome",
        "frut_disorder_pome",

        "frut_overall_keepqual",
        "frut_overall_appear",
        "frut_overall_color",
        "frut_overall_texture",
        "frut_overall_taste",
        "frut_overall_eatqual",
        "frut_overall_interest"
    ],
    measures: [
        "frut_length",
        "frut_weight",
        "frut_diameter",
        "frut_firmness",
        "frut_tss",
        "frut_acid",
        "frut_acid_citric",
        "frut_acid_tart",
        "frut_pear_starch_scale",
        "frut_juiciness",
        "frut_ground_color_ctifl",
        "frut_over_color_ctifl",
        "frut_over_color",
        "frut_cheek_1",
        "frut_cheek_2",
    ],

    calculations: [
        "sugar_acid_ratio_calc",
    ],

    indexes: [
        "indx_frut_eating_quality",
        "indx_frut_overall"
    ],

}